// extracted by mini-css-extract-plugin
export default {"panelHeader":"FLQRo9yoig6Uy9GjBRKG","backIcon":"NhyuWEXgBona8_cCByRx","mobilePanelHeader":"GTM8QunILgyXqBHsqN5F","mobilePanelHeaderShadow":"GK3UcqoT6kAOJ59K_jCl"};